import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { isBlockBlockedProfile } from '../redux/actions/auth';
import { BlockUnblockModal } from '../components';

const useIsBlockApi = ({
  profile,
  redirectPath = window.location.pathname,
  isCheck,
  stopVideo,
  content,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { token } = useSelector((state) => state.auth);
  const [previousToken, setPreviousToken] = useState(token);
  const [isTriggerBlockModal, setTriggerBlockModal] = useState(false);
  const [blockType, setBlockType] = useState('block');

  useEffect(() => {
    if (previousToken === '') {
      setPreviousToken('');
    }
  }, [previousToken]);

  const checkIsBlocked = useCallback(
    async (profile) => {
      try {
        const res = await dispatch(
          isBlockBlockedProfile(profile.accountId, profile.id)
        );
        if (res?.data?.status === 'BLOCKING') {
          setBlockType('unblock');
          setTriggerBlockModal(true);
          stopVideo && stopVideo(true);
          return true;
        }
        if (res?.data?.status === 'BLOCKED') {
          setTriggerBlockModal(true);
          setBlockType('access');
          stopVideo && stopVideo(true);
          return true;
        }
        setTriggerBlockModal(false);
        setBlockType('block');
      } catch (error) {}
    },
    [dispatch, stopVideo]
  );

  const onCloseBlockModal = (type) => {
    if (type === 'unblocked') {
      checkIsBlocked(profile);
      stopVideo && stopVideo(false);
    }
    if (type !== 'unblocked') {
      history.push(redirectPath);
    }
    setTriggerBlockModal(false);
  };

  useEffect(() => {
    // isCheck to check if run this hook. If its not true then check for block unblock
    // only run this api when user logsIn from loggedOut State
    if (token && !isCheck && content) {
      checkIsBlocked(profile);
    }
  }, [token, previousToken, checkIsBlocked, profile, isCheck, content]);

  if (profile && isTriggerBlockModal) {
    return (
      <BlockUnblockModal
        profile={profile}
        blockType={blockType}
        isTriggered={isTriggerBlockModal}
        onClose={onCloseBlockModal}
      />
    );
  }
};

export default useIsBlockApi;
